module.exports = __webpack_public_path__ + "img/activity_gold.75b6fb16.png";